import React, { useEffect, useState } from 'react'
import './assets/emailConfiramtion.css'
import Modal from 'react-bootstrap/Modal';
import { useCookies, withCookies } from 'react-cookie';
import { FontAwesomeIcon } from '../../../../../CommonComponents/AssetsHelper';
import { Button } from 'react-bootstrap';
const EmailVerifiedPopup = (props) => {

	const [show, setShow] = useState(false);
	const [, , removeCookie] = useCookies();

	useEffect(() => {
		setShow(true)
	}, [])

	return (
		<div>
			<Modal show={show} size="md" centered>
				<div id="email_confirmation_valid" className="emailverify modalfade react-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
					<div className='modal-body'>
						<div className="py-4">
							<div className="text-center mb-4">
								<FontAwesomeIcon type={'solid'} icon={'circle-check'} iconClass={'display-1 text-success'} />
								<h3 className="text-center my-3 font-weight-boldest display-6">Email Verified</h3>
								<p className="font-weight-bold text-dark-75 text-center">
									Your account has been successfully verified. Time to explore your SocialWalls account!</p>
							</div>
							<div className="f-center">
								<Button onClick={()=>{removeCookie('emailConfirmation', { path: '/' });props.onClickToCloseConfirm()}} type="button" className="btn btn-lg btn-primary ms-2 text-nowrap mb-3 btn-min-w" data-bs-dismiss="modal" id="verifiedemail" aria-label="Close">Let's Go</Button>
							</div>
						</div>
					</div>

				</div>
			</Modal>
			<div className="modal-overlay--blur"></div>
		</div>
	)
}

export default withCookies(EmailVerifiedPopup)



